import React from 'react';
import { Stack, Button, Portal } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParameterizedQuery } from 'react-fetching-library';
import { getDocuments, sendSetOfDocumentsAction } from '../../../../../../services/request';
import { SnackbarAlert } from '../../../../../../components-core/SnackbarAlert';
import AgreementButton from './AgreementButton';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';

const DocumentsButtons = () => {
  const [snackbar, setSnackbar] = React.useState({ open: false, severity: 'error', message: 'Wystąpił błąd' });
  const { order } = useSelector(state => state.app);
  const { query } = useParameterizedQuery(getDocuments);
  const { query: sendQuery } = useParameterizedQuery(sendSetOfDocumentsAction);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleOpenSnackbar = (severity, message) => setSnackbar({ open: true, severity, message });

  const handleClick = async (template_name, fileName, annex_id = 0) => {
    const { payload, error, loading } = await query(order.id, template_name, annex_id);
    if (!error && !loading) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${fileName}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  };

  const handleSend = async () => {
    const { error, loading } = await sendQuery(order.id);
    if (!error && !loading) {
      handleOpenSnackbar('success', 'Komplet dokumentów został wysłany');
    }

    if (error) {
      handleOpenSnackbar('error', 'Nie udało się wysłać kompletu dokumentów');
    }
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <AgreementButton order={order} getDocument={handleClick} />
      <Button
        variant="contained"
        disabled={order.state !== 'CON'}
        onClick={() => handleClick('qualification_card', 'karta kwalifikacyjna')}
      >
        Karta kwalifikacyjna
      </Button>
      <Button
        variant="contained"
        disabled={order.state !== 'CON'}
        onClick={() => handleClick('terms_of_participation', 'warunki uczestnictwa')}
      >
        Warunk uczestnictwa
      </Button>
      <Button
        variant="contained"
        disabled={order.state !== 'CON'}
        onClick={handleSend}
        endIcon={<AttachEmailIcon />}
      >
        Wyślij komplet dokumentów
      </Button>
      <Portal>
        <SnackbarAlert open={snackbar.open} severity={snackbar.severity} message={snackbar.message} onClose={handleCloseSnackbar} />
      </Portal>
    </Stack>
  );
};


export default DocumentsButtons;
